import React, { useMemo, useState, useEffect } from "react";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Repeatability_Edit_Offcanvas from "../Repeatability_Edit_Offcanvas/Repeatability_Edit_Offcanvas";
import Delete_offcanvas from "../../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../../utils/fixIDS";
import { Delete, GetAll } from "../../../../../../../../features/admin/quality_management/process_requirement/repeatability/Slice";

function Repeatability_table({ data, currentPage, setCurrentPage, refreshData }) {
  const itemsPerPage = 10;

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const dispatch = useDispatch();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const maxObservations = Math.max(
    ...(data?.data?.map(
      (row) => row?.Selection_Type_Record_Observations?.length || 0,
    ) || [0]),
  );

  

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      //fetchCustomers(currentPage); // refresh the table
      if (refreshData) refreshData();
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(FixIDS.repeatability.Edit);
  const haveDeletePermission = permissions?.includes(
    FixIDS.repeatability.Delete,
  );
  

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th rowSpan="2">Sr. No</th>
                  <th rowSpan="2">Date</th>
                  <th rowSpan="2">Test Method</th>
                  <th rowSpan="2">Sample Id</th>
                  <th rowSpan="2">Test Type</th>
                  <th rowSpan="2">Certified Value</th>
                  <th rowSpan="2">Checked By</th>
                  <th rowSpan="2">Remark</th>

                  {maxObservations > 0 && (
                    <th colSpan={maxObservations} className="text-center">
                      Observations
                    </th>
                  )}

                  <th rowSpan="2">Avg.</th>
                  <th rowSpan="2">SD</th>
                  <th rowSpan="2">RSD%</th>
                  <th rowSpan="2">Action</th>
                </tr>

                {maxObservations > 0 && (
                  <tr>
                    {Array.from({ length: maxObservations }).map((_, i) => (
                      <th key={i}>OBS {String(i + 1).padStart(2, "0")}</th>
                    ))}
                  </tr>
                )}
              </thead>

              <tbody>
                {data?.data?.length > 0 ? (
                  data?.data?.map((row, index) => {
                    const observations =
                      row?.Selection_Type_Record_Observations || [];

                    return (
                      <tr key={row.id || index}>
                        <td>{index + 1}</td>
                        <td>{formatDate(row?.date) || "-"}</td>
                        <td>{row?.Test_Method?.name || "-"}</td>
                        <td>{row?.Sample_Management?.unique_id || "-"}</td>
                        <td>{row?.Test_Type?.name || "-"}</td>
                        <td>{row?.certified_value || "-"}</td>
                        <td>{row?.User?.name || "-"}</td>
                        <td>{row?.remark || "-"}</td>

                        {Array.from({ length: maxObservations }).map((_, i) => (
                          <td key={i}>
                            {observations[i]?.observation_value || "-"}
                          </td>
                        ))}

                        <td>{row?.average || "-"}</td>
                        <td>{row?.std_deviation || "-"}</td>
                        <td>{row?.rsd || "-"}</td>
                        {/* Action */}
                        <td>
                          <div className="action_icons">
                            {haveEditPermission && (
                              <FontAwesomeIcon
                                icon={faPen}
                                onClick={() => {
                                  setEdit(true);
                                  setEditId(row.id);
                                }}
                              />
                            )}
                            {haveDeletePermission && (
                              <FontAwesomeIcon
                                icon={faTrashCan}
                                onClick={() => {
                                  setSelectedDeleteId(row.id); // store ID
                                  setDelete(true); // open offcanvas
                                }}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={maxObservations + 6} className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <div className="note_text_holder">
        <p>* Results Are In Air Dried Basis.</p>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p>
            Showing {(currentPage - 1) * (data?.per_page || itemsPerPage) + 1}{" "}
            to{" "}
            {Math.min(
              currentPage * (data?.per_page || itemsPerPage),
              data?.total || 0,
            )}{" "}
            of {data?.total || 0} entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={handlePageChange}
            totalPages={data?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      {/* Edit */}
      {haveEditPermission && (
        <Repeatability_Edit_Offcanvas
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
          refreshData={refreshData}
        />
      )}

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Repeatability"
          massageText={"Repeatability"}
        />
      )}
    </>
  );
}

export default Repeatability_table;
